<template>
    <div class="suggestions">
        <ag-table :data-source-api="getAllSuggestions" :grid-options="gridOptions" :permissions="permissions" :rtl="false"
        :is-entities-response="false">
        </ag-table>
        <tm-popup title="تفاصيل الاقتراح" ref="suggestionPopup">
            <div class="vx-row justify-start">
                <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
                    <tm-input class="w-full" name="الاسم" placeholder="الاسم" type="text" v-model="suggestion.name" readonly="true"/>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
                    <tm-input class="w-full" name="رقم الموبايل" placeholder="رقم الموبايل" type="text" v-model="suggestion.phoneNumber" readonly="true"/>
                </div>
                <div class="vx-col w-full mb-2 mt-4">
                    <p class="mt-2 px-2" style="font-size: smaller">الاقتراح</p>
                    <tm-text-area class="w-full" name="الاقتراح" v-model="suggestion.suggestion" readonly="true"/>
                </div>
            </div>
        </tm-popup>
    </div>
</template>

<script>
import { RepositoryFactory } from '../volunteer-repositories/volunteerRepositoryFactory';
import AgTable from '../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import AgTableBtnCell from "../../shared/shared-components/ag-grid/AgTableBtnCell";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmInput from "@/app/shared/shared-components/TmInput";
import TmTextArea from "@/app/shared/shared-components/TmTextArea";



const suggestionsRepo = RepositoryFactory.get('suggestionsRepository');
export default {
    name: "Suggestions",
    components: {
        AgTable,
        AgTableBtnCell,
        TmPopup,
        TmInput,
        TmTextArea,
    },
    data() {
        return {
        gridApi: null,
        gridOptions: null,
        permissions: {
            add: 'volunteer_manage',
            edit: 'volunteer_manage',
            delete: 'volunteer_manage',
        },
        suggestion: {
            name: null,
            phoneNumber: null,
            suggestion: null,
        },
        };
    },
    methods: {
        createColDefs() {
        let self = this;
        return [
            {
            headerName: 'معرف المتطوع',
            field: 'volunteerId',
            // filter: 'agNumberColumnFilter',
            sortable: false,
            width: 200,
            },
            {
            headerName: 'الاسم',
            field: 'name',
            filter: 'agTextColumnFilter',
            width: 210,
            sortable: false,
            },
            {
            headerName: 'رقم الموبايل',
            field: 'phoneNumber',
            filter: 'agTextColumnFilter',
            width: 210,
            sortable: false,
            },
            {
            headerName: 'الإقتراح',
            field: 'suggestion',
            filter: 'agTextColumnFilter',
            width: 210,
            sortable: false,
            },
            {
                headerName: "الإجراءات",
                cellRendererFramework: AgTableBtnCell,
                sortable: false,
                valueGetter: function getObject(params) {
                    return params.data;
                },
                cellRendererParams: {
                    viewRecordDetails: function (suggestion) {
                        self.onViewSuggestion(suggestion);
                    },
                    actions: ["view"],
                    permissions: self.permissions,
                },
            },
        ];
        },
        async getAllSuggestions(query) {
        return await suggestionsRepo.fetchSuggestions(query);
        },
        onViewSuggestion(suggestion) {
            Object.assign(this.suggestion, suggestion);
            this.$refs.suggestionPopup.open();
        },
    },
    created() {
        this.gridOptions = {};
        this.gridOptions.columnDefs = this.createColDefs();
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
};
</script>